import React from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import NotFound from 'pages/not-found';
import ProtectedLayout from 'components/protected-layout';
import LoaderProvider from 'providers/LoaderProvider';
import Loader from 'components/loader';
import LinkEsaadCard from 'pages/essad-card/link-esaad-card';
import OTPVerification from 'pages/essad-card/otp-verification';
import EsaadLayout from 'components/esaad-card/esaad-layout';
import { ROUTES } from 'constants';
import Success from 'pages/essad-card/status/success';
import Failure from 'pages/essad-card/status/failure';
import Admin from 'pages/admin-login-page';
import AdminPage from 'pages/admin-home-page';
import UpdatePassword from 'components/update-password';
import HealthCheck from 'pages/health-check';
import Cookies from 'universal-cookie';

const NavigationE = () => {

  const ProtectedRoute = ({ element }) => {
    const cookies = new Cookies();
    const token = cookies.get('token');

    return token ? element : <Navigate to="/admin" />;
  };

  return (
    <>
      <BrowserRouter basename="/partnership-portal">
        <LoaderProvider>
          <Routes>
            <Route element={<HealthCheck />} path="/health-check" />
            <Route exact path={ROUTES.PARTNERSHIP_PORTAL.ROOT} element={<ProtectedLayout />}/>
            <Route exact path={ROUTES.ADMIN_PAGE.LOGIN} element={<Admin />} />
            <Route
              exact
              path={ROUTES.ADMIN_PAGE.HOME}
              element={<ProtectedRoute element={<AdminPage />} />}
            />
            <Route
              exact
              path={ROUTES.ADMIN_PAGE.UPDATE_PASSWORD}
              element={<ProtectedRoute element={<UpdatePassword />} />}
            />

            <Route element={<EsaadLayout />}>
              <Route path={ROUTES.ESAAD_CARD.ROOT} element={<LinkEsaadCard />} />
              <Route path={ROUTES.ESAAD_CARD.OTP_VERIFY} element={<OTPVerification />} />
              <Route path={ROUTES.ESAAD_CARD.SUCCESS} element={<Success />} />
              <Route path={ROUTES.ESAAD_CARD.FAILURE} element={<Failure />} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Loader />
        </LoaderProvider>
      </BrowserRouter>
    </>
  );
};

NavigationE.propTypes = {
  element: PropTypes.element
};

export default NavigationE;
